
import {valueListToArray} from '../../libs/array/valueListToArray.js';

export const toStringValueList = (...args) => {
  if (args.length == 0)
    return '';
  if (args.length == 1)
    return (typeof(args[0]) == 'string') ? args[0] : valueListToArray(args[0]).join(' ');
  return args.map(v => (typeof(v) == 'string') ? v : valueListToArray(v).join(' ')).join(' ');
};
